import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { login, checkSession, onsession, MyLibraryLogIn } from './module';

const initialState = {
    status: "idle",
    dataUrl: null,
    ActionStatus: "",
    errorMessage: ""
};

export const loginAsync = createAsyncThunk(
    'login/login',
    async (data, ThunkAPI) => {
        // console.log("data",data)
        const response = await login(data);
        return response;
    }
);

export const checkSessionAsync = createAsyncThunk(
    'login/checkSession_RV',
    async (index, ThunkAPI) => {
        const response = await checkSession();
        return response;
    }
);

export const MyLibraryLogInAsync = createAsyncThunk(
    'marriageForm/MyLibraryLogIn',
    async (data, ThunkAPI) => {
        const response = await MyLibraryLogIn(data);
        return response;
    }
);

// export const onsessionAsync = createAsyncThunk(
//     'login/onsession',
//     async (index, ThunkAPI) => {
//         const response = await onsession();
//         return response;
//     }
// );

export const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(loginAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(loginAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(loginAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage)
            } else {
                sessionStorage.setItem('ue', action.payload.RequestorEmail);
                sessionStorage.setItem('up', action.payload.RequestorMobile);
                window.location.href = "./otp";
            }
        });

        builder.addCase(checkSessionAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(checkSessionAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(checkSessionAsync.fulfilled, (state, action) => {
            state.status = 'idle';

            if (action.payload && action.payload.Status === 'OK') {
                window.location.href = "./requests"
            }
        });
        builder.addCase(MyLibraryLogInAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(MyLibraryLogInAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(MyLibraryLogInAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            // if (!action.payload) {
            //     state.dataUrl = null;
            //     console.log("no url")
            //     return;
            // }
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.dataUrl = action.payload.LoginUrl;
            }
        });
        // builder.addCase(onsessionAsync.pending, (state) => {
        //     state.status = 'loading';
        // });
        // builder.addCase(onsessionAsync.rejected, (state) => {
        //     state.status = 'rejected';
        // });
        // builder.addCase(onsessionAsync.fulfilled, (state, action) => {
        //     state.status = 'idle';

        //     if(action.payload && action.payload.Status === 'OK'){
        //         window.location.href="./requests"
        //     }
        // });
    },
});

export const curlocation = (state) => state.Session.curlocation;
export const mySession = (state) => state.Session.mySession;
export const pagesState = (state) => state.login;
export const myLibs = (state) => state.Session.myLibs;

export default loginSlice.reducer;
